import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { AppLoggerService } from '../logging/app-logger.service';

interface PermissionDebugPayload {
  route: ActivatedRouteSnapshot;
  allowed: boolean;
  mode: 'access' | 'permissions';
  required: unknown;
  userPermissions: string[];
}

@Injectable({ providedIn: 'root' })
export class PermissionDebugLoggerService {
  constructor(private readonly logger: AppLoggerService) {}

  log(payload: PermissionDebugPayload): void {
    const routePath = payload.route.routeConfig?.path ?? '(unknown)';
    this.logger.debug(
      `permission.guard.${payload.allowed ? 'allow' : 'deny'}`,
      {
        routePath,
        mode: payload.mode,
        required: payload.required,
        userPermissions: payload.userPermissions,
      },
      'PermissionGuard'
    );
  }
}
